module.exports = __webpack_public_path__ + "img/tmp-patients-status-8.978a1fb7.svg";